<template>
  <el-popover placement="bottom" width="400" trigger="manual" v-model="visible">
    <upload />
    <div
      class="btn-text can-hover"
      type="text"
      slot="reference"
      @click="visible = !visible"
    >
      <el-badge :value="number" :hidden="number === 0">
        <i class="fa fa-cloud-upload"></i>
      </el-badge>
    </div>
  </el-popover>
</template>
<script>
import upload from '@/components/upload'
import { mapGetters } from 'vuex'
export default {
  components: {
    upload,
  },
  data() {
    return {
      visible: false,
    }
  },
  computed: {
    ...mapGetters('admin/upload',['number'])
  },
}
</script>
<style lang="scss">
.header-uploader {
  width: 400px;
  max-width: 400px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  .arrow::before {
    border-bottom-color: #ebeef5;
  }
}
// .uploader {
//   .el-badge__content.is-fixed {
//     position: absolute;
//     top: 10px;
//     right: 20px;
//   }
// }
</style>
